export const UPDATE_ID = 'order/UPDATE_ID'
export const UPDATE_PAYMENT_DATE = 'order/UPDATE_PAYMENT_DATE'
export const UPDATE_PAYMENT_METHOD = 'order/UPDATE_PAYMENT_METHOD'
export const UPDATE_PAYMENT_STATUS = 'order/UPDATE_PAYMENT_STATUS'
export const UPDATE_STATUS = 'order/UPDATE_STATUS'
export const UPDATE_TOTAL_AMOUNT = 'order/UPDATE_TOTAL_AMOUNT'
export const UPDATE_SHIPPING_COST = 'order/UPDATE_SHIPPING_COST'
export const UPDATE_BALANCE_DUE = 'order/UPDATE_BALANCE_DUE'
export const UPDATE_PACKAGE_LIST = 'order/UPDATE_PACKAGE_LIST'
export const UPDATE_REDEEM_LIST = 'order/UPDATE_REDEEM_LIST'